export const GET_CLIENT_VIDEOS_LIMIT = 20;
